import { black } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import styled from 'styled-components'
import Thumbnail from './Thumbnail'
import { breakpoints } from '@/theme/tokens'

/**
 * Single row of three idea thumbnails. Content-sized and top-aligned so a
 * grid-stretched tile leaves whitespace below instead of ballooning thumbs.
 */
export const ThumbGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	align-content: start;
	gap: 14px 12px;

	/* Phone: a two-up grid (design m-ideas-grid). */
	@media (max-width: ${breakpoints.phone}px) {
		grid-template-columns: 1fr 1fr;
		gap: 12px;
	}
`

export const ThumbCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
	min-width: 0;
`

export const IdeaThumb = styled(Thumbnail)`
	width: 100%;
	/* Square thumbnails — height tracks the column width. */
	aspect-ratio: 1 / 1;
`

export const ThumbTitle = styled.div`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 12.5px;
	color: ${black};
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`
